import { replaceWords } from '@dooray/i18n-extract/src/replaceWords';

import { LOCALE, LOCALE_CODE } from '~/constants';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import { get } from 'lodash';
import { initReactI18next } from 'react-i18next';

import logging from './stores/providers/logging';
// the translations
// (tip move them in a JSON file and import them)

interface PostProcessor {
  type: 'postProcessor';
  name: string;
  process: (value: string, key: string, options: any, translator: { language: string }) => string;
}

const resourceError = () => Promise.reject(new Error('not found language resource'));

const lazyResourceMap = {
  ko: () => import('./i18n/ko.json'),
  en: () => import('./i18n/en.json'),
  ja: () => import('./i18n/ja.json'),
  zh: () => import('./i18n/zh.json'),
};

const getResource = (language: string) => get(lazyResourceMap, language, resourceError)();

const localeCodeMap = {
  [LOCALE.KO]: LOCALE_CODE.KO_KR,
  [LOCALE.EN]: LOCALE_CODE.EN_US,
  [LOCALE.JA]: LOCALE_CODE.JA_JP,
  [LOCALE.ZH]: LOCALE_CODE.ZH_CN,
};

function replaceSource(source: object, language: LOCALE_CODE) {
  const translateTarget = process.env.REACT_APP_TRANSLATE_TARGET;
  if (translateTarget !== 'mnd') {
    return source;
  }
  const locale = localeCodeMap[language];
  const newSource = {
    [locale]: source,
  };
  const replacedSource = replaceWords(newSource, translateTarget, [locale]);
  return replacedSource[locale];
}

let beforeLoading = true;

const checkBeforeLoading: PostProcessor = {
  type: 'postProcessor',
  name: 'checkBeforeLoading',
  process: function (...args) {
    if (beforeLoading) {
      logging.warn('before loading value', ...args);
    }
    return args[0];
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(checkBeforeLoading)
  .use(
    resourcesToBackend((language: string, __namespace: string, callback) => {
      getResource(language)
        .then((resources: any) => {
          beforeLoading = false;
          callback(null, replaceSource(resources.default, language as LOCALE_CODE));
        })
        .catch((error: Error) => {
          callback(error, null);
        });
    })
  )
  .init({
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      bindI18n: 'languageChanged',
    },
    postProcess: ['checkBeforeLoading'],
  });

export default i18n;
